<template>
  <div>
    <div class="mb-4">
      <label class="titlePage">Tratamento - Candidatos</label>

      <div class="mt-4 row">
        <div class="col-4">
          <fcc-select
            class="mr-2"
            label-field="cidadeprova"
            value-field="codcidexame"
            v-model="cidade"
            :options="cidades"
            :clearable="false"
            required
            >Cidade de Prova</fcc-select
          >
        </div>

        <div class="col-2">
          <fcc-select
            class="mr-2"
            label-field="periodo"
            value-field="iddatacidade"
            v-model="periodo"
            :options="periodos"
            :clearable="false"
            required
            :disabled="!cidade"
            >Período</fcc-select
          >
        </div>

        <div class="col-4">
          <fcc-select
            class="mr-2"
            label-field="colegio"
            value-field="codvirtual"
            v-model="colegio"
            :options="colegios"
            :clearable="false"
            :disabled="periodo === null"
            required
            >Colégio</fcc-select
          >
        </div>

        <div class="col-2">
          <fcc-select
            class="mr-2"
            label-field="sala"
            value-field="sala"
            v-model="sala"
            :options="salas"
            :clearable="false"
            :disabled="cidade === null || colegio === null || periodo === null"
            required
            >Sala</fcc-select
          >
        </div>
      </div>

      <div class="mt-4 row justify-content-end">
        <div class="col-auto">
          <fccButton :disabled="sala === null" @click="buscar">{{ labelsSystem.buscar }}</fccButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '../../../../../store'

export default {
  props: ['cidadesDeProva', 'colegios', 'salas'],
  data() {
    return {
      cidade: null,
      colegio: null,
      sala: null,
      periodo: null
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    },
    cidades() {
      return (
        this.cidadesDeProva &&
        this.cidadesDeProva.reduce((acc, curr, idx) => {
          if (idx === 0) return [curr]
          else {
            if (acc[acc.length - 1].codcidexame === curr.codcidexame) return acc
            else return [...acc, curr]
          }
        }, [])
      )
    },
    periodos() {
      return this.cidadesDeProva.filter((item) => item.codcidexame === this.cidade)
    }
  },
  methods: {
    resetData() {
      this.cidade = null
      this.colegio = null
      this.sala = null
    },
    buscar() {
      this.$emit('buscar', {
        cidade: this.periodo,
        colegio: this.colegio,
        sala: this.sala
      })
    }
  },
  watch: {
    configuracao() {
      this.resetData()
    },
    cidade(value) {
      this.colegio = null
      this.sala = null
      this.periodo = null
      if (value) this.$emit('buscar-colegios', value)
    },
    colegio(value) {
      this.sala = null
      if (value) this.$emit('buscar-salas', value)
    }
  }
}
</script>